import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import AADHeader from "./components/AADHeader.js";

const getComingSoonLink = (name) =>
  `/comingsoon?source=insights&name=${encodeURIComponent(name)}`;

const INSIGHT_CARDS = [
  {
    title: "Assessing low RE % sites",
    subtitle: "Potential Emission Reductions and Consolidated RE%",
    href: getComingSoonLink("Assessing low RE % sites"),
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="13" width="4" height="7" rx="1" fill="#D9D9D9" />
        <rect x="10" y="9" width="4" height="11" rx="1" fill="#F5C518" />
        <rect x="16" y="11" width="4" height="9" rx="1" fill="#FFFFFF" />
      </svg>
    ),
  },
  {
    title: "Electricity cost evaluation",
    subtitle: "Identifying Viable Alternatives",
    href: getComingSoonLink("Electricity cost evaluation"),
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="6" stroke="#FFFFFF" strokeWidth="2" fill="none" />
        <line x1="14.5" y1="14.5" x2="19" y2="19" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
        <polyline points="7,11 9,8 11,10 13,6" stroke="#F5C518" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Assessing electricity usage across sites",
    subtitle: "Identifying High-Intensity Locations",
    href: getComingSoonLink("Assessing electricity usage across sites"),
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" stroke="#D9D9D9" strokeWidth="3" fill="none" />
        <circle cx="12" cy="12" r="8" stroke="#F5C518" strokeWidth="3" fill="none" strokeDasharray="14 36" strokeDashoffset="4" transform="rotate(-90 12 12)" />
      </svg>
    ),
  },
];

export default function Home() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading=""/>;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  return (
    <div id="wrapper">
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div class="container formpd">
          <div class="flex">
            <div class="col-md-9 pd-0">
              <div class="steps__containt-hader">
                <h3 class="title">Insights</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Typography color="text.primary" component="span">
                      Insights
                    </Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div class="col-md-3 pd-0"></div>
          </div>

          <div className="insights-cards-row">
            {INSIGHT_CARDS.map((card) => (
              <Link key={card.href} to={card.href} className="insight-card">
                <div className="insight-card__icon">{card.icon}</div>
                <h4 className="insight-card__title">{card.title}</h4>
                <p className="insight-card__subtitle">{card.subtitle}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
